import VerticalLine_ClassicVerticalDottedLineComponent from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/skinComps/BaseVerticalLine/ClassicVerticalDottedLine.skin';
import VerticalLine_ClassicVerticalDottedLineController from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/VerticalLine.controller';


const VerticalLine_ClassicVerticalDottedLine = {
  component: VerticalLine_ClassicVerticalDottedLineComponent,
  controller: VerticalLine_ClassicVerticalDottedLineController
};


export const components = {
  ['VerticalLine_ClassicVerticalDottedLine']: VerticalLine_ClassicVerticalDottedLine
};

